import { type GetStaticProps } from 'next';
import configureSentryScope from '../helpers/configureSentryScope';
import getDownloadPageViewModels from '../helpers/getDownloadPageViewModels';
import DownloadPage from '../components/DownloadPage/DownloadPage';

export const DownloadPagePath = '/download';

export default DownloadPage;

const translationKeys = [
  'archon.download_page_hero_heading',
  'archon.app_name',
  'archon.download_page_subheading',
  'archon.download_for_os',
  'global.os_windows',
  'global.os_macos',
  'global.os_linux',
  'global.new',
  'global.coming_soon_titlecase',
  'archon.supported_games',
  'archon.download_feature_logging_heading',
  'archon.download_feature_logging_body',
  'archon.download_feature_logging_coming_soon_text',
  'archon.download_feature_vod_heading',
  'archon.download_feature_vod_body',
  'archon.download_feature_analysis_heading',
  'archon.download_feature_analysis_body',
  'archon.download_feature_group_finder_heading',
  'archon.download_feature_group_finder_body',
  'archon.download_feature_meters_heading',
  'archon.download_feature_meters_body',
  'archon.download_feature_meta_heading',
  'archon.download_feature_meta_body',
  'archon.download_only_available_on_platform',
  'archon.download_the_archon_app',
  'archon.archon_app_lite_desc',
  'archon.archon_app_lite_download_text',
];

export const getStaticProps: GetStaticProps = async ({ params }) => {
  configureSentryScope(params);

  const pageViewModels = await getDownloadPageViewModels(translationKeys);

  return {
    props: {
      googleAnalytics: pageViewModels.googleAnalytics,
      translations: pageViewModels.translations,
      header: pageViewModels.header,
      footer: pageViewModels.footer,
      page: pageViewModels.downloadPage,
    },
    revalidate: 300,
  };
};
